import {createSlice} from '@reduxjs/toolkit';

import _ from 'lodash';
import API from '../../app/api';
import config from '../../app/config';
import {setLoadingPref} from './additionalData';
import {setSnackbar} from './globals';
import {CONTEXT_OPTIONS} from '../../pages/appointments/utils/constants/appointmentSessionConstants';

export const preferencesSlice = createSlice({
    name: 'preferences',
    initialState: {
        patient: {
            thumbnailSize: 'small',
            initiallyOpen: 3,
            filters: null,
            sortStudy: 'date',
            historyBarPosition: 'top',
            filtersList: [],
            selectedFilterName: null,
            selectedFilterDocName: null,
            fontSize: 12,
            color: '#e66465',
            studiesTypeViews: {},
            smartView: [],
            filtersDocList: [],
            showMode: null,
            smartViewDefault: {},
        },
        patientCurrent: null,
        currentTheme: null,
        viewer: {},
        searchHistoryEyonix:[],
        holding: {
            pageSelected: 1,
            documentsCount: 1,
            pageSize: config.modules.holdingPen.pageSize,

        },
        specialties: [],
        agyle: {
            waitingSort: [],
            showSnomedCode: true,
            filtersModalOpen: false,
            topMenuMode: 'open',
            timestampsDisplay: 'close',
            timestampsDisplayLast: null,
            priorityColumnOrder: null,
            referralsMode: null,
            referralsColumnOrder: null,
            timestampColumnOrder: null,
            bedBookingColumnOrder: null,
            defaultNoteType: 'clinical',
            defaultNoteFilter: 'all',
            inMessageColumnOrder: [],
            outMessageColumnOrder: [],
            fhirMessageColumnOrder: [],
            dictAuditColumnsOrder: [],
            snackbar: {vertical: 'bottom', horizontal: 'left'},
            searchHistory: {
                patientSearch: [],
                admitSearch: [],
            },
            chartObs: {
                wheel: 'scroll',
            },
            customMap: null,
            switchMapMode: 'auto',
            defaultStartingPage: '',
            defaultSchedulerView: CONTEXT_OPTIONS.SWIM_LANES,
            wardMap: {
                startingPanel: 'left',
                defaultMapEnabled: false,
                defaultMap: '',
                defaultHospital: '',
                favorites: [],
                lastVisit: [],
            },
            mapCreator: {
                swapPanel: false,
            },
            bookedAdmissionsCardConfig: {
                tciSchedule: null,
                tciScheduleList: null,
                tciUnscheduledList: null,
                search: null,
                mduSchedule: null,
                mduScheduleList: null,
                mduUnscheduledList: null,
            },
            bookedAdmissions: {
                view: null,
                landingPage: null,
                defaultConsultantToMe: false,
                timeFormatInMinutes: null,
                defaultCalendarAdmissionType: null,
                defaultFormAdmissionType: null,
                dashboard: {
                    // timeRange: "week",
                    // workload: "patients",
                    // sessionType: "all",
                    // tableDataView: "table",
                    // specialtiesAll: false,
                    // specialtiesSet: [],
                    // theatersAll: false,
                    // theatersSet: []
                },
            },
            bedManagement: {
                widgets: [],
                columnPreferences: null,
                mainScreenWidgets: null,
                tableColumns: {
                    mainTable: [],
                    mainTableSticky: 5,
                    bedTable: [],
                    bedTableSticky: {
                        bedStatus: 6,
                        siderooms: 6,
                        breaches: 4,
                        outliers: 5,
                        offWard: 9,
                        porterView: 6,
                        cleaningRequest: 4,
                    },
                },
            },
            avatar: {
                customAvatar: {
                    active: false,
                    picture: null,
                },
                defaultActive: true,
                avatarBackground: '#C6DFFF',
                avatarFontColor: '#C6DFFF',
            },
            loadedFromApi: false,
            formActionBarMode: 'top', // 'top', 'withBottom'
            favouritesAssessments: [],
        },
        allPreferences: null,
    },
    reducers: {
        setPatientPreference: (state, preference) => {
            function customizer(obj, src) {
                if (_.isArray(obj)) {
                    return src;
                }
            }

            state.patient = 'patient' in preference.payload ?
                _.mergeWith(state.patient, preference.payload.patient, customizer) :
                _.mergeWith(state.patient, preference.payload, customizer);
        },
        setPatientCurrentPreference: (state, preference) => {
            state.patientCurrent = 'patient' in preference.payload ? preference.payload.patient : preference.payload;
        },
        setViewerPreference: (state, preference) => {

        },
        setSearchPreference: (state, preference) => {

        },
        setHoldingPreference: (state, preference) => {
            state.holding = _.merge(state.holding, preference.payload);
        },
        setSpecialties: (state, preference) => {
            if (Array.isArray(preference.payload)) {
                state.specialties = [...preference.payload];
            } else {
                if ('specialties' in preference.payload) {
                    state.specialties = [...preference.payload.specialties];
                } else {
                    state.specialties = [];
                }
            }
        },
        setAgylePrefFromApi: (state, preference) => {
            if ('agyle' in preference.payload) {
                state.agyle = {
                    ...state.agyle,
                    ...preference.payload.agyle,
                    loadedFromApi: true,
                };
            }
        },
        setAgylePref: (state, preference) => {
            state.agyle = {
                ...state.agyle,
                ...preference.payload,
            };
        },
        setAllPreferences: (state, preference) => {
            state.allPreferences = preference.payload;
        },
        setCurrentTheme: (state, preferenceTheme) => {
            state.currentTheme = preferenceTheme.payload.currentTheme ? preferenceTheme.payload.currentTheme : 'dark';
        },
        setBedManagementPreference: (state, preference) => {
            state.agyle.bedManagement = {
                ...state.agyle.bedManagement,
                ...preference.payload,
            };
        },
        setAvatarPreference: (state, preference) => {
            state.agyle.avatar = {
                ...state.agyle.avatar,
                ...preference.payload,
            };
        },
    },
});

export const {
    setPatientPreference,
    setPatientCurrentPreference,
    setViewerPreference,
    setSearchPreference,
    setHoldingPreference,
    setSpecialties,
    setAllPreferences,
    setCurrentTheme,
    setAgylePrefFromApi,
    setAgylePref,
    setBedManagementPreference,
    setAvatarPreference,
} = preferencesSlice.actions;

export const patient = state => state.preferences.patient;
export const currentTheme = state => state.preferences.currentTheme;
export const patientCurrent = state => state.preferences.patientCurrent;
export const viewer = state => state.preferences.viewer;
export const search = state => state.preferences.search;
export const holding = state => state.preferences.holding;
export const agylePref = state => state.preferences.agyle;
export const specialties = state => state.preferences.specialties ? state.preferences.specialties : [];
export const bedManagement = state => state.preferences.agyle.bedManagement;
export const favouritesAssessments = state => state.preferences.agyle.favouritesAssessments;

// export const currentTheme = state => {
//     return window._getThemeObject(state.preferences.currentTheme);
// };

export const loadPref = () => (dispatch, getState) => {
    dispatch(setLoadingPref(true));
    API.getPref().then(res => {
        if (!_.isEmpty(res.data)) {
            dispatch(setPatientPreference(res.data));
            dispatch(setPatientCurrentPreference(res.data));
            dispatch(setSpecialties(res.data));
            dispatch(setAllPreferences(res.data));
            dispatch(setCurrentTheme(res.data));
            dispatch(setAgylePrefFromApi(res.data));
            window._setTheme(getState().preferences.currentTheme);
            dispatch(setLoadingPref(false));
        }
    });

};

export const savePref = (data, {noUpdateCurrent = false, showSnackbar = true} = {}) => (dispatch, getState) => {
    API.setPref(data).then(res => {
        if (res.data) {
            dispatch(setPatientPreference(data));
            if (!noUpdateCurrent) dispatch(setPatientCurrentPreference(data));
            if (showSnackbar) dispatch(setSnackbar({type: "success", message: "Preference saved."}));
        } else {
            dispatch(setSnackbar({type: 'error', message: 'An error occurred while saving preferences.'}));
        }
    });
};

export const saveSpecialties = (specialties) => (dispatch, getState) => {
    let s = {...getState().preferences.allPreferences};
    s.patient = getState().preferences.patient;
    s.specialties = specialties;
    API.setPref(s).then(res => {
        if (res.data) {
            dispatch(setSpecialties(specialties));
            dispatch(setSnackbar({type: 'success', message: 'Specialties changed.'}));
        } else {
            dispatch(setSnackbar({type: 'error', message: 'Specialties not changed.'}));
        }
    });
};

export const saveAgylePreference = (pref, afterSaveSuccess = false, afterSaveError = false, showSnackbar = false) => (dispatch, getState) => {
    let s = {...getState().preferences.allPreferences};
    let agylePref = {
        ..._.cloneDeep(getState().preferences.agyle),
        ...pref,
    };
    delete agylePref['loadedFromApi'];
    s.patient = getState().preferences.patient;
    s.agyle = agylePref;
    API.setPref(s).then(res => {
        if (res.data) {
            dispatch(setAgylePref(pref));
            afterSaveSuccess && afterSaveSuccess();
            if (showSnackbar) {
                dispatch(setSnackbar({type: 'success', message: 'Preference saved.'}));
            }
        } else {
        }
    }).catch(err => {
        console.error('error pref', err);
        dispatch(setSnackbar({type: 'error', message: 'An error occurred while saving preferences.'}));
        afterSaveError && afterSaveError();
    });
};

export const saveCurrentTheme = (theme, showConfirmation = true) => (dispatch, getState) => {
    let s = {...getState().preferences.allPreferences};
    s.currentTheme = theme;
    API.setPref(s).then(res => {
        if (res.data) {
            dispatch(setCurrentTheme(res.data));

            if (showConfirmation) {
                dispatch(setSnackbar({type: 'success', message: 'Preference saved.'}));
            }
        }
    }).catch(err => showConfirmation &&
        dispatch(setSnackbar({type: 'success', message: 'An error occurred while saving preferences.'})),
    );
};

export const getGroup = () => (dispatch, getState) => {
    return getState().preferences.patient.sortStudy;
};

export const cloneCurrentPref = () => (dispatch, getState) => {
    dispatch(setPatientCurrentPreference(getState().preferences.patient));
};

export const getInitiallyOpen = () => (dispatch, getState) => {
    return getState().preferences.patient.initiallyOpen;
};

export default preferencesSlice.reducer;
